/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2021-05-11 17:19:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-11 17:19:14
 * @FilePath: \heshan_web\src\util\global.js
 */
export default {
  ws: {},
  setWs: function setWs(newWs) {
    this.ws = newWs;
  }
};